module.exports = __webpack_public_path__ + "img/broken_link.1aafbd1d.svg";